import { ApolloError } from '@apollo/client';
import { Alert } from 'antd';

const QueryErrorBoundary = ({
  error,
  children,
}: {
  error?: ApolloError | (ApolloError | undefined)[] | null;
  children: React.ReactNode;
}) => {
  let filteredErrors = error;

  if (Array.isArray(error)) {
    filteredErrors = error.filter(Boolean) as ApolloError[];
  }

  if (
    !error ||
    (Array.isArray(filteredErrors) && filteredErrors.length === 0)
  ) {
    return <>{children}</>;
  }

  if (Array.isArray(error)) {
    return (
      <>
        {error?.map((err, index) => {
          if (!err) return;
          return (
            <Alert
              key={index}
              message={err?.message}
              description="There was an error processing your request. Please try again."
              type="error"
              showIcon
              closable
            />
          );
        })}
      </>
    );
  }

  return (
    <Alert
      message={error?.message}
      description="There was an error processing your request. Please try again."
      type="error"
      showIcon
      closable
    />
  );
};

export default QueryErrorBoundary;
